import React, { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import { useParams, useHistory } from 'react-router-dom'
import {
  FeatherLoader,
  Button,
  useNotificationService,
  useErrorService,
} from '@abroad/components'
import API from '../../utils/API'
import AddQuestModal from './AddQuestModal'
import {
  UTCFormatDate,
  getCurrentDate,
  sortedByDate,
  getcurrentDateUsingProps,
  getProgramDatesRange,
} from '../../utils/date'
import moment from 'moment-timezone'
const ClientQuest = ({ refetchClientProfile }) => {
  const history = useHistory()
  const Error = useErrorService()
  const { clientId } = useParams()
  const Notification = useNotificationService()
  const [isLoading, setIsLoading] = useState(false)
  const [clientQuest, setClientQuest] = useState([])
  const [questList, setQuestList] = useState([])
  const [showModal, setShowModal] = useState(false)

  const handleAddNewQuestClick = () => {
    setShowModal(true)
  }
  const handleCloseModal = () => {
    setShowModal(false)
  }
  const getClientProfileQuests = async () => {
    setIsLoading(true)
    try {
      const { data } = await API.AdminAPI.quests.getClientProfileQuest(clientId)
      setClientQuest(data)
      setIsLoading(false)
    } catch (e) {
      Error.showError(e)
      setIsLoading(false)
    }
  }

  const handleQuestUpdate = async () => {
    await getClientProfileQuests()
    if (refetchClientProfile) {
      await refetchClientProfile()
    }
  }
  const deleteQuest = async (questId) => {
    try {
      await API.AdminAPI.quests.deleteQuestUser(questId, clientId)
      Notification.showNotification('User has been deleted!', 'success')
      getClientProfileQuests()
    } catch (e) {
      Error.showError(e)
    }
  }

  useEffect(() => {
    getClientProfileQuests()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId])
  useEffect(() => {
    const getQuests = async () => {
      setIsLoading(true)
      try {
        const { data } = await API.AdminAPI.quests.getQuestList({
          page: 1,
          limit: 500,
          isArchived: false,
        })
        const sortedQuestList = sortedByDate(data)
        const currentDate = getCurrentDate()
        const questList = sortedQuestList.filter((item) => {
          const { start: startDate, end: endDate } = getProgramDatesRange(item)
          const start = getcurrentDateUsingProps(startDate)
          const end = getcurrentDateUsingProps(endDate)
          return (
            (currentDate >= start && currentDate <= end) || currentDate <= start
          )
        })
        setQuestList(questList)
        setIsLoading(false)
      } catch (e) {
        Error.showError(e)
        setIsLoading(false)
      }
    }
    getQuests()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setQuestList, setIsLoading])

  const handleQuestClick = (questId) => {
    history.push(`/admin/experiences/${questId}`)
  }

  return (
    <div className='mt-3'>
      <div className='d-flex'>
        <h3 className='s3 mb-0'>Experiences</h3>
        {questList?.length > 0 && (
          <Button
            variant='outline-dark'
            className='btn s8 text-uppercase border-radius-3 line-height-normal outline-dark-btn add-gp-btn'
            onClick={handleAddNewQuestClick}>
            ADD USER TO EXPERIENCE
          </Button>
        )}
      </div>
      <Table hover responsive className='custom-table mb-0 mt-1'>
        <thead>
          <tr>
            <th width='20%'>QUEST NAME</th>
            <th width='20%'>MONTH & YEAR</th>
            <th width='20%'>START DATE</th>
            <th width='20%'>END DATE</th>
            <th width='20%'>Action</th>
          </tr>
        </thead>
        <tbody>
          {isLoading && (
            <tr>
              <td colSpan='5' className='text-center border-0'>
                <FeatherLoader />
              </td>
            </tr>
          )}

          {clientQuest.length === 0 && !isLoading && (
            <tr>
              <td colSpan='5' className='text-center border-0'>
                User is not enrolled in any experiences yet.
              </td>
            </tr>
          )}
          {clientQuest.map((quest, index) => (
            <tr key={index}>
              <td
                width='30%'
                onClick={() => handleQuestClick(quest.questId._id)}
                className='cursor-pointer'>
                {quest?.questId?.name}
              </td>
              <td width='20%'>
                {(() => {
                  const { start, end } = getProgramDatesRange(quest.questId)
                  if (!start || !end) return 'N/A'
                  const startMoment = moment.utc(start)
                  const endMoment = moment.utc(end)
                  if (
                    startMoment.month() === endMoment.month() &&
                    startMoment.year() === endMoment.year()
                  ) {
                    return `${startMoment.format('MMMM YYYY')}`
                  }
                  if (startMoment.year() === endMoment.year()) {
                    return `${startMoment.format('MMMM')} - ${endMoment.format(
                      'MMMM YYYY',
                    )}`
                  }
                  return `${startMoment.format(
                    'MMMM YYYY',
                  )} - ${endMoment.format('MMMM YYYY')}`
                })()}
              </td>
              <td width='20%'>
                {(() => {
                  const { start } = getProgramDatesRange(quest.questId)
                  return start ? UTCFormatDate(start) : '-'
                })()}
              </td>
              <td width='20%'>
                {(() => {
                  const { end } = getProgramDatesRange(quest.questId)
                  return end ? UTCFormatDate(end) : '-'
                })()}
              </td>
              <td
                width='20%'
                className='text-saffron-700 cursor-pointer'
                onClick={() => deleteQuest(quest?.questId?._id)}>
                Remove
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <AddQuestModal
        showModal={showModal}
        handleClose={handleCloseModal}
        updateClientProfile={handleQuestUpdate}
        questList={questList}
      />
    </div>
  )
}

export default ClientQuest
